const Counterdata = [
  {
    id: 1,
    number: 6,
    title: 'Continents'
  },
  {
    id: 2,
    number: 8,
    title: 'Offered Sectors'
  },
  {
    id: 3,
    number: 365,
    title: 'Days of Client Support'
  },
  {
    id: 4,
    number: 4,
    title: 'Office Locations'
  }
]

export default Counterdata
